import { AppRouteProps } from "@bsm/component";
import React from "react";

const ParamsUserDetailsContainer = React.lazy(() => import('./containers/ParamsStudentDetailsContainer'))
export const ParamsUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'params',
        title: '{{StudentNameDetailsTab}}',
        element: <ParamsUserDetailsContainer />
    }
]